export const  PASSWORD_RESET_CLIENT =  `
    mutation resetPasswordClient($id_client: ID!, $new_password: String!) {
        resetPasswordClient(id_client: $id_client, new_password: $new_password) {
        message
        result
        }
    }
`;